import * as React from 'react';
import * as classNames from 'classnames';

// FIXME : Probably this reference is a bad idea.
import { TabInfo, TabType } from '../../reducers/pages';

import { getBasePath } from '../../utils/browser';
import IconImage from '../common/IconImage';

interface NewTabProps {
  active: boolean;
  title: string;
  iconUrl: string;
  isReflowableContent: boolean;
  onClick: () => void;
  onClose: () => void;
}

const NewTab: React.SFC<NewTabProps> = React.memo((props) => {
  const borderImage = props.active ? 'tab_border_active' : 'tab_border_inactive';
  const closeButtonImage = props.active ? 'btn_tab_close_active' : 'btn_tab_close_inactive';
  const baseDir = getBasePath();

  const wrapperStyle: React.CSSProperties = {
    minWidth: props.active ? '48px' : '38px',
    boxSizing: 'border-box',
    // アクティブなタブの左右隙間を大き目に取る簡易対応
    padding: `2px ${props.active ? '5px' : '3px'}`,
    paddingTop: props.active ? '2px' : '4px',
    fontSize: '16px',
  };

  const tabStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    height: props.active ? '46px' : '34px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: props.active ? '#fff' : '#d1cfc4',
    border: '4px solid',
    borderImageSource: `url("${baseDir}/images/tabbar/new/${borderImage}.png")`,
    borderImageSlice: '8',
    borderImageOutset: '2px',
  };

  const iconStyle: React.CSSProperties = {
    flexShrink: 0,
    boxSizing: 'border-box',
    width: '20px',
    height: '20px',
    marginLeft: props.active ? '5px' : '2px',
    marginRight: '5px',
  };

  const textStyle: React.CSSProperties = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    color: '#363636',
  };

  const closeStyle: React.CSSProperties = {
    flexShrink: 0,
    width: '16px',
    height: '16px',
    marginLeft: '5px',
    marginRight: props.active ? '5px' : '2px',
  };

  const iconSvgStyle: React.CSSProperties = {
    width: '20px',
    height: '20px',
  };

  return (
    <div
      style={wrapperStyle}
      onClick={props.onClick}
      className={classNames({ active: props.active })}>
      <div style={tabStyle}>
        <div style={iconStyle}><IconImage src={props.iconUrl} svgStyle={iconSvgStyle} /></div>
        <span style={textStyle} title={props.title}>
          {`${props.isReflowableContent ? 'テキスト表示 | ' : ''}${props.title}`}
        </span>
        <img
          style={closeStyle}
          src={`${baseDir}/images/tabbar/new/${closeButtonImage}.png`}
          aria-label="Close"
          onClick={(ev) => { ev.stopPropagation(); props.onClose(); }} />
      </div>
    </div>
  );
});

export interface NewTabbarProps {
  tabs: ReadonlyArray<TabInfo>;
  activeTabIndex: number; // XXX : Should this be key instead of index?
  onSelect: (index: number) => void;
  onCloseButtonClick: (index: number) => void;
}

const tabbarStyle: React.CSSProperties = {
  height: '50px',
  backgroundColor: '#666',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'left',
  flexWrap: 'nowrap',
  boxSizing: 'border-box',
  paddingLeft: '64px',
};

export const NewTabbar: React.SFC<NewTabbarProps> = React.memo((props) => {
  const resolveIconUrl = (tab: TabInfo) => {
    const baseDir = getBasePath();

    switch (tab.type) {
      case TabType.LinearPages:
        return `${baseDir}/images/tabbar/new/icon_linear_pages.png`;
      case TabType.ReflowablePages:
      case TabType.GeneratedContent:
        return `${baseDir}/images/tabbar/new/icon_reflowable_pages.png`;
      case TabType.ExtraPage:
        return tab.favicon || `${baseDir}/images/tabbar/new/icon_extra_page.png`;
    }
  };

  const tabs = props.tabs.map((tab, index) => {
    const active = index === props.activeTabIndex;
    const select = () => props.onSelect(index);
    const close = () => props.onCloseButtonClick(index);

    return (
      <NewTab
        key={index}
        active={active}
        iconUrl={resolveIconUrl(tab)}
        title={tab.title}
        isReflowableContent={tab.type === TabType.ReflowablePages}
        onClick={select}
        onClose={close} />
    );
  });

  return <div id="viewer-tab-bar" style={tabbarStyle}>{tabs}</div>;
});
